import { useThrottleFn } from "@vueuse/core";

// 复制
export function copyText(text: string) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
}

// 节流DOM元素到底部
export const handleScrollToBottom = useThrottleFn((refElement: HTMLElement) => {
  nextTick(() => {
    if (!!refElement) {
      refElement.scrollTop = refElement.scrollHeight;
    }
  });
}, 1000);
